import { render } from "./addConfig.vue?vue&type=template&id=dc8be39a&scoped=true&ts=true"
import script from "./addConfig.vue?vue&type=script&setup=true&lang=ts"
export * from "./addConfig.vue?vue&type=script&setup=true&lang=ts"

import "./addConfig.vue?vue&type=style&index=0&id=dc8be39a&scoped=true&lang=css"

import exportComponent from "D:\\Work\\IMMS\\IMMSV3\\App\\IMMS.MasterClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc8be39a"],['__file',"src/views/applications/pop/addConfig.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dc8be39a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dc8be39a', __exports__)) {
    console.log('reload')
    api.reload('dc8be39a', __exports__)
  }
  
  module.hot.accept("./addConfig.vue?vue&type=template&id=dc8be39a&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('dc8be39a', render)
  })

}


export default __exports__